import * as React from "react";
import { forwardRef } from "react";
const SvgRcSidebar = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 48, viewBox: "0 -960 960 960", width: 48, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M80-160v-640h800v640H80Zm603-443h137v-137H683v137Zm0 186h137v-126H683v126ZM140-220h483v-520H140v520Zm543 0h137v-137H683v137Z" }));
const ForwardRef = forwardRef(SvgRcSidebar);
export { ForwardRef as ReactComponent };
